import { Empty, Modal } from "antd";
import SortingArrow from "../../Common/SortingArrow";
import { Link } from "react-router-dom";
import { getTabFromOrderStatus } from "../../utils/helper/utils";
// import { useDispatch } from "react-redux";

const AllOrders = ({ isOpen, onCancel, data }) => {
  // const dispatch = useDispatch();

  //const [list,setList] = useState([]); //list,
  // const [paginationModel,setPaginationModel] = useState(paginationLimit); //setPaginationModel
  // const [inputData, setInputData] = useState({});
  // const [totalRows,setTotalRows] = useState(0); //totalRows

  const handleSort = (column, order) => {
    // setInputData((prev) => ({
    //   ...prev,
    //   order_by: column,
    //   order_type: order,
    // }));
  };

  return (
    <>
      <Modal title="All Orders" centered open={isOpen} onCancel={onCancel} width={360} footer={null}>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  S.No <SortingArrow onSort={() => handleSort()} />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Order Number <SortingArrow onSort={() => handleSort()} />
                </th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => {
                  return (
                    <tr className="bg-white border-b" key={index}>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">{item?.id}</td>
                      <td className="px-3 py-4 vertical-top">
                        <span className="flex items-center hover:bg-[#176b5320] text-[#176b53] text-center px-[12px] py-[8px] rounded w-fit h-[32px] cursor-pointer">
                          <Link
                            className="cursor-pointer"
                            to={`/order-management/?order_number=${item?.orderNumber}`}
                            state={{
                              orderNumber: item?.orderNumber,
                              activeTab: getTabFromOrderStatus(item?.status)
                            }}
                            style={{ color: "#37846B", fontWeight: 500 }}
                          >
                            {item?.orderNumber}
                          </Link>
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={13} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* <div className="text-right mt-4">
          <Pagination />
        </div> */}
      </Modal>
    </>
  );
};
export default AllOrders;
